import React, { useState } from 'react';
import { getRetencionesPracticadas, getRetencionesAFavor, getRetencionesAFavorDetalle } from '../services/api';

const fmt = (n) => '$' + Math.round(Number(n || 0)).toLocaleString('es-CO');
const fecha = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const hoy = new Date();
const primero = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().slice(0, 10);
const ultimo = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).toISOString().slice(0, 10);

export default function ReportesRetenciones() {
  const [tab, setTab] = useState('practicadas');
  const [desde, setDesde] = useState(primero);
  const [hasta, setHasta] = useState(ultimo);
  const [loading, setLoading] = useState(false);
  const [practicadas, setPracticadas] = useState(null);
  const [aFavor, setAFavor] = useState(null);
  const [expand, setExpand] = useState({});      // documento/cliente abierto
  const [detalle, setDetalle] = useState({});    // cache de detalle a favor por cliente

  const cargar = async () => {
    setLoading(true);
    try {
      if (tab === 'practicadas') {
        const { data } = await getRetencionesPracticadas({ desde, hasta });
        setPracticadas(data);
      } else {
        const { data } = await getRetencionesAFavor({ desde, hasta });
        setAFavor(data);
        setDetalle({});
      }
      setExpand({});
    } catch (e) { alert(e.response?.data?.error || 'Error al cargar'); }
    finally { setLoading(false); }
  };

  const toggleCliente = async (c) => {
    const k = c.cliente_id;
    setExpand(e => ({ ...e, [k]: !e[k] }));
    if (!detalle[k]) {
      try {
        const { data } = await getRetencionesAFavorDetalle({ cliente_id: k, desde, hasta });
        setDetalle(d => ({ ...d, [k]: data }));
      } catch (_) {}
    }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Reportes de retención</h1><p style={s.sub}>Por documento (practicadas) y por cliente (a favor)</p></div>
      </div>

      <div style={s.bar}>
        <div style={s.tabs}>
          <button style={{ ...s.tab, ...(tab === 'practicadas' ? s.tabOn : {}) }} onClick={() => setTab('practicadas')}>Practicadas (compras)</button>
          <button style={{ ...s.tab, ...(tab === 'afavor' ? s.tabOn : {}) }} onClick={() => setTab('afavor')}>A favor (ventas)</button>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <label style={s.lbl}>Desde</label><input type="date" style={s.input} value={desde} onChange={e => setDesde(e.target.value)} />
          <label style={s.lbl}>Hasta</label><input type="date" style={s.input} value={hasta} onChange={e => setHasta(e.target.value)} />
          <button style={s.btn} onClick={cargar} disabled={loading}>{loading ? 'Cargando…' : 'Consultar'}</button>
        </div>
      </div>

      {tab === 'practicadas' && practicadas && (
        <div style={s.card}>
          <table style={s.table}>
            <thead><tr>{['Documento', 'Proveedor', 'Fecha', 'Base', 'Retenido'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {practicadas.documentos.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin retenciones practicadas en el período.</td></tr>}
              {practicadas.documentos.map(d => (
                <React.Fragment key={d.documento + d.nit}>
                  <tr style={{ cursor: 'pointer' }} onClick={() => setExpand(e => ({ ...e, [d.documento]: !e[d.documento] }))}>
                    <td style={{ ...s.td, color: '#93c5fd', fontWeight: 600 }}>{expand[d.documento] ? '▾' : '▸'} {d.documento}</td>
                    <td style={s.td}>{d.proveedor}</td>
                    <td style={s.td}>{fecha(d.fecha)}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{fmt(d.base)}</td>
                    <td style={{ ...s.td, textAlign: 'right', color: '#fca5a5', fontWeight: 600 }}>{fmt(d.total_retenido)}</td>
                  </tr>
                  {expand[d.documento] && d.conceptos.map((c, i) => (
                    <tr key={i} style={{ background: '#0f172a' }}>
                      <td style={{ ...s.td, paddingLeft: 32, color: '#94a3b8' }} colSpan={3}>{c.concepto}</td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#94a3b8' }}>{fmt(c.base)}</td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#cbd5e1' }}>{fmt(c.valor)}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
            {practicadas.documentos.length > 0 && <tfoot><tr><td colSpan={4} style={{ ...s.td, textAlign: 'right', fontWeight: 700 }}>Total retenido</td><td style={{ ...s.td, textAlign: 'right', fontWeight: 700, color: '#fca5a5' }}>{fmt(practicadas.total_retenido)}</td></tr></tfoot>}
          </table>
        </div>
      )}

      {tab === 'afavor' && aFavor && (
        <div style={s.card}>
          <table style={s.table}>
            <thead><tr>{['Cliente', 'NIT', 'Facturas', 'Retefuente', 'ReteICA', 'ReteIVA', 'Total'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {aFavor.length === 0 && <tr><td colSpan={7} style={s.empty}>Sin retenciones a favor en el período.</td></tr>}
              {aFavor.map(c => (
                <React.Fragment key={c.cliente_id}>
                  <tr style={{ cursor: 'pointer' }} onClick={() => toggleCliente(c)}>
                    <td style={{ ...s.td, color: '#93c5fd', fontWeight: 600 }}>{expand[c.cliente_id] ? '▾' : '▸'} {c.razon}</td>
                    <td style={s.td}>{c.nit}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{c.facturas}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{fmt(c.retefuente)}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{fmt(c.reteica)}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{fmt(c.reteiva)}</td>
                    <td style={{ ...s.td, textAlign: 'right', color: '#34d399', fontWeight: 600 }}>{fmt(c.total)}</td>
                  </tr>
                  {expand[c.cliente_id] && (detalle[c.cliente_id] || []).map((d, i) => (
                    <tr key={i} style={{ background: '#0f172a' }}>
                      <td style={{ ...s.td, paddingLeft: 32, color: '#94a3b8' }}>{d.factura} · {fecha(d.fecha)}</td>
                      <td style={s.td} colSpan={2}></td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#94a3b8' }}>{fmt(d.retefuente)}</td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#94a3b8' }}>{fmt(d.reteica)}</td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#94a3b8' }}>{fmt(d.reteiva)}</td>
                      <td style={{ ...s.td, textAlign: 'right', color: '#cbd5e1' }}>{fmt(d.total)}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          <p style={{ color: '#64748b', fontSize: 12, padding: '8px 12px' }}>Nota: las retenciones a favor se muestran por total (retefuente/reteICA/reteIVA). El desglose por concepto llegará cuando el pago capture la retención por concepto.</p>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader: { marginBottom: 10 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  bar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' },
  tabs: { display: 'flex', gap: 6 },
  tab: { background: '#1e293b', border: '1px solid #334155', color: '#94a3b8', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  tabOn: { background: '#1d4ed8', borderColor: '#1d4ed8', color: '#fff' },
  lbl: { color: '#94a3b8', fontSize: 12 },
  input: { height: 34, padding: '0 10px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9', fontSize: 13 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  card: { background: '#1e293b', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '10px 12px', color: '#64748b', fontSize: 12, textAlign: 'left', borderBottom: '1px solid #334155', background: '#162032' },
  td: { padding: '8px 12px', color: '#cbd5e1', fontSize: 13, borderBottom: '1px solid #1a2332' },
  empty: { padding: '24px', textAlign: 'center', color: '#475569', fontSize: 13 },
};
